<footer class="bg-gray-800 text-white py-12">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
      <!-- Company Info Section -->
      <div>
        <div class="flex items-center space-x-3 mb-4">
          <img 
            src="/assets/images/logos/Hector_Group_Logo_White.png" 
            alt="Hector Group Logo" 
            class="w-16 h-16 object-cover"
          />
          <div>
            <span class="text-xl font-bold">Hector Global</span>
            <div class="text-xs text-amber-400">Investment Institution</div>
          </div>
        </div>
        <p class="text-gray-400">
          Unlock global investment opportunities with us
        </p>
      </div>

      <!-- Dynamic Footer Sections -->
      <div *ngFor="let section of footerSections">
        <h4 class="font-semibold mb-4">{{ section.title }}</h4>
        <ul class="space-y-2 text-gray-400">
          <li *ngFor="let link of section.links">
            <a 
              [href]="link.href" 
              class="hover:text-white transition-colors"
              (click)="onLinkClick($event, link.href)"
            >
              {{ link.label }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Copyright Section -->
    <div class="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
      <p>&copy; {{ currentYear }} Hector Investment. All rights reserved. | www.hectorinvestment.ai</p>
    </div>
  </div>
</footer>